import React from 'react';
import useReveal, { reveal } from '../../hooks/useReveal';

const STEPS = [
  {
    title: 'Book a demo',
    body: 'Half an hour with someone who knows schools, walking through AtadaBoard against how your school actually works.',
  },
  {
    title: 'We set up your school',
    body: 'Our team creates your school, loads your classes and staff, and brings your existing student records across.',
  },
  {
    title: 'Train your team',
    body: 'We work with your administrators, accountants and teachers until they can run a normal week without us.',
  },
  {
    title: 'Go live',
    body: 'Parents are invited in, and the register, reports and billing start running through AtadaBoard.',
  },
];

const Onboarding = () => {
  const [ref, isVisible] = useReveal();

  const scrollToDemo = () =>
    document.getElementById('demo-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  return (
    <section id="onboarding" className="ab-section ab-section--tint ab-steps" ref={ref}>
      <div className="ab-shell ab-steps__grid">
        <div className={`ab-steps__aside ${reveal(isVisible)}`}>
          <h2 className="ab-h2">Getting started</h2>
          <p className="ab-body">
            You are not handed a login and left to it. We set the school up with you and stay through
            the first term.
          </p>
          <button type="button" className="ab-btn ab-btn--primary" onClick={scrollToDemo}>
            Book a demo
          </button>
        </div>

        <ol className="ab-steps__list">
          {STEPS.map((step, index) => (
            <li
              key={step.title}
              className={reveal(isVisible)}
              style={{ '--ab-reveal-delay': `${index * 80}ms` }}
            >
              <span className="ab-num ab-steps__index" aria-hidden="true">
                {index + 1}
              </span>
              <div>
                <h3 className="ab-h3">{step.title}</h3>
                <p className="ab-body">{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>

      <style jsx>{`
        .ab-steps__grid {
          display: grid;
          grid-template-columns: minmax(0, 0.72fr) minmax(0, 1.28fr);
          gap: clamp(2rem, 5vw, 4.5rem);
          align-items: start;
        }

        .ab-steps__aside {
          position: sticky;
          top: 120px;
        }

        .ab-steps__aside .ab-body { margin: 1rem 0 1.75rem; }

        .ab-steps__list {
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .ab-steps__list li {
          display: flex;
          gap: clamp(1rem, 2vw, 1.75rem);
          padding: 1.75rem 0;
          border-bottom: 1px solid var(--ab-line-strong);
        }

        .ab-steps__list li:first-child { padding-top: 0; }
        .ab-steps__list li:last-child { border-bottom: 0; padding-bottom: 0; }

        .ab-steps__index {
          flex-shrink: 0;
          font-family: var(--ab-font-display);
          font-size: 1.25rem;
          font-weight: 600;
          line-height: 1;
          color: var(--ab-blue);
          padding-top: 0.1875rem;
        }

        .ab-steps__list .ab-h3 { margin-bottom: 0.4375rem; }
        .ab-steps__list .ab-body { font-size: 0.9375rem; }

        @media (max-width: 860px) {
          .ab-steps__grid { grid-template-columns: minmax(0, 1fr); }
          .ab-steps__aside { position: static; }
        }
      `}</style>
    </section>
  );
};

export default Onboarding;
